module.exports = __webpack_public_path__ + "static/img/logo_white.43b24f58.png";